import React from 'react';
import {
  Dialog, DialogTitle, DialogContent, DialogActions,
  Button, TextField, Typography,
} from '@mui/material';

const FlagDisputeDialog = ({ open, onClose, disputeReason, onDisputeReasonChange, onSubmit }) => (
  <Dialog
    open={open}
    onClose={onClose}
    maxWidth="sm"
    fullWidth
  >
    <DialogTitle>Flag Item as Disputed</DialogTitle>
    <DialogContent>
      <Typography variant="body2" color="text.secondary" sx={{ mt: 1, mb: 2 }}>
        Please provide a reason for flagging this item as disputed. All parties will be notified.
      </Typography>
      <TextField
        margin="dense"
        label="Dispute Reason"
        fullWidth
        multiline
        rows={4}
        variant="outlined"
        value={disputeReason}
        onChange={(e) => onDisputeReasonChange(e.target.value)}
      />
    </DialogContent>
    <DialogActions>
      <Button onClick={onClose}>Cancel</Button>
      <Button
        onClick={onSubmit}
        variant="contained"
        color="error"
        disabled={!disputeReason.trim()}
      >
        Flag as Disputed
      </Button>
    </DialogActions>
  </Dialog>
);

export default FlagDisputeDialog;
